module.exports = __webpack_public_path__ + "static/img/task.23e50a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/task.png
// module id = Yh9Q
// module chunks = 0